import { userInviteAccepted } from '@/lib/analytics/Avo';

export const trackInviteAccepted = () => {
  userInviteAccepted();
};
